import { render, staticRenderFns } from "./ReturnNotes.vue?vue&type=template&id=4fe65db8&"
import script from "./ReturnNotes.vue?vue&type=script&lang=js&"
export * from "./ReturnNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports